export default __webpack_public_path__ + "static/media/explore2.142013da.png";